<template>
  <v-row
    align="center"
    no-gutters
  >
    <v-col :cols="addBtn || edit ? '10' : '12'">
      <Reference
        :value="value"
        :label="label"
        :placeholder="placeholder"
        :items.sync="items"
        :total-items="totalItems"
        :hide-details="hideDetails"
        :error-messages="errorMessages"
        :multiple-select="multipleSelect"
        :append="append"
        :component-name="componentName"
        @input="$emit('input', $event)"
        @getItems="getItems"
        @add="addBlock"
      />
    </v-col>
    <v-col
      v-if="addBtn || edit"
      :cols="addBtn || edit ? '2' : '0'"
      class="pa-0"
    >
      <ItemEditCard
        v-if="addBtn"
        :label="label"
        :loading="loading"
        placeholder="Введіть тег або теги через ';'"
        @handler="addTags"
      />
      <v-btn
        v-if="edit"
        icon
        color="green"
        class="ml-1"
        @click="$emit('edit')"
      >
        <v-icon>check</v-icon>
      </v-btn>
      <v-btn
        v-if="edit"
        icon
        color="primary"
        class="ml-1"
        @click="$emit('close')"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import * as tagsApi from "../../backend/tagsApi.js";
import Reference from "../../components/Reference.vue";
import ItemEditCard from "../../components/ItemEditCard.vue";

export default {
  components: {
    Reference,
    ItemEditCard,
  },
  props: {
    label: {
      type: String,
      default: "Теги",
    },
    value: {
      type: [Object, Array],
    },
    placeholder: {
      type: String,
      default: "Введіть теги",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    addBtn: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    append: {
      type: Boolean,
      default: false,
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
    componentName: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    totalItems: 0,
    items: [],
    menu: false,
    loading: false,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await tagsApi.selectTag(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
    async addTags(value) {
      if (!value) {
        return;
      }
      this.loading = true;
      const tags = value.split(";");
      const cleanTags = tags.map((t) => t.trim().toLowerCase());
      try {
        const newTags = await tagsApi.createTag(cleanTags.filter(Boolean));
        this.$emit("add", newTags);
        this.loading = false;
      } catch (err) {
        this.$notifyWarning(err.response.data);
        this.loading = false;
      }
    },
    addBlock(valueId) {
      this.$emit("add-block", { blockId: valueId, order: 1 });
    },
  },
};
</script>
